export const QA_NAME_SELECT_CONTEXT = 'Select'

export const QA_NAME_SELECT_DROPDOWN_CONTEXT =
  QA_NAME_SELECT_CONTEXT + 'Dropdown'
